import { tw } from '@/utils/tw';
import BaseHamburgerTheme from 'base/components/Hamburger/theme';

const Hamburger = tw.theme({
  extend: BaseHamburgerTheme,
  slots: {
    base: `h-5 w-5`,
    segment: `bg-black`,
  },
});

export default Hamburger;
